import * as React from 'react';

import { Button } from '@acceligentllc/storybook';

import CustomModal from 'af-components/CustomModal';

import styles from './styles.module.scss';

interface Props {
	imageSrc: string;
	showModal: boolean;
	closeModal: () => void;
}

const ImagePreviewModal = (props: Props) => {
	const { imageSrc, showModal, closeModal } = props;

	const baseClassName = 'modal';
	const bodyClassName = `${baseClassName}__body`;

	const imgClassName = 'img-preview';

	return (
		<CustomModal
			className={styles[baseClassName]}
			closeModal={closeModal}
			modalStyle="info"
			showModal={showModal}
			size="xl"
		>
			<CustomModal.Header
				closeModal={closeModal}
				title="IMAGE PREVIEW"
			/>
			<CustomModal.Body className={styles[bodyClassName]}>
				<img className={styles[imgClassName]} src={imageSrc} />
			</CustomModal.Body>
			<CustomModal.Footer>
				<Button
					label="Close"
					onClick={closeModal}
					style="secondary"
				/>
			</CustomModal.Footer>
		</CustomModal>
	);
};

export default React.memo(ImagePreviewModal);
